import React, { useEffect, useState } from "react";
import { useClientCategories } from "../../hooks";
import CheckboxWrapper from "./Checkbox.style";
import { Typography, Checkbox, Tooltip, Tag } from "antd";
import { useIntl } from "react-intl";
import { WarningOutlined, InfoCircleOutlined } from "@ant-design/icons";
import PartialOrderTooltip from "./PartialOrderTooltip";
import moment from "moment";
import DeleteEventsButton from "./DeleteEventsButton";
const { Title } = Typography;
var tinycolor = require("tinycolor2");

const OrderListItem = (props) => {
  const {
    order,
    order_time_extractions,
    ordersPalette,
    onFilterOrdersChanged,
    mode,
    events,
    showApproved,
    filteredOrders,
    currentDate,
  } = props;
  const [name, setName] = useState(null);
  const [required, setRequired] = useState(null);
  const [planned, setPlanned] = useState(null);
  const [approved, setApproved] = useState(null);
  const [isTotalOrder, setIsTotalOrder] = useState(null);
  const [color, setColor] = useState("inherit");
  const clientCategories = useClientCategories();
  const intl = useIntl();
  const isChecked = filteredOrders && !filteredOrders.includes(order.id);
  useEffect(() => {
    setName(order && order["client"] ? order && order["client"]["name"] : "");
    if (order && order["client"]) {
      const startsInCurrentMonth =
        order.effective_from &&
        moment(order.effective_from) >= moment().startOf("month");
      const endsInCurrentMonth =
        order.effective_to &&
        moment(order.effective_to) <= moment().endOf("month");
      let color =
        ordersPalette[order["client"]["category"]["name"]] || "#C31A57";
      if (startsInCurrentMonth && endsInCurrentMonth) {
        color = tinycolor(color).darken(15).desaturate(10).toHexString(); // "#f53d3d"
      } else if (endsInCurrentMonth) {
        color = tinycolor(color).darken(30).desaturate(10).toHexString(); // "#f53d3d"
      }
      setColor(color);
    }
    const orderTimes = order_time_extractions[order.id];

    const orderEvents = events
      ? events.filter((i) => i.order_id === order.id)
      : null;

    const scheduled_minutes = orderEvents
      ? orderEvents.reduce((a, b) => +a + +(b.duration_minutes || 0), 0)
      : orderTimes.scheduled_minutes;

    const approvedEvents = orderEvents
      ? orderEvents.filter((i) => i.approved === true)
      : null;
    const approved_minutes = approvedEvents
      ? approvedEvents.reduce((a, b) => +a + +(b.duration_minutes || 0), 0)
      : 0;

    setRequired(
      mode === "scheduling"
        ? Math.round(
            orderTimes.required_total_minutes !== 0
              ? (orderTimes.required_total_minutes / 60) * 100
              : (orderTimes.required_minutes / 60) * 100
          ) / 100
        : Math.round((orderTimes.required_weekly_minutes / 60) * 100) / 100
    );
    setPlanned(
      mode === "scheduling"
        ? Math.round(
            orderTimes.accumulated_total_minutes !== 0
              ? (orderTimes.accumulated_total_minutes / 60) * 100
              : (scheduled_minutes / 60) * 100
          ) / 100
        : Math.round((orderTimes.planned_weekly_minutes / 60) * 100) / 100
    );
    setApproved(Math.round((approved_minutes / 60) * 100) / 100);
    setIsTotalOrder(
      (mode === "scheduling" && orderTimes.accumulated_total_minutes !== 0) ||
        (mode !== "scheduling" && orderTimes.required_total_minutes !== -1)
    );
  }, [order, order_time_extractions, clientCategories, ordersPalette]);

  const onChange = (e) => {
    onFilterOrdersChanged(order.id, e.target.checked);
  };

  const unApprovedEvents = events
    ? events.filter((i) => i.order_id === order.id && !i.approved)
    : [];

  const renderDeleteButton =
    approved === required && unApprovedEvents.length > 0;
  return (
    <div className="providerContainer">
      <div className="providerTitle">
        <CheckboxWrapper checkboxColor={color}>
          {order.supporting_community ? (
            <label className="ant-checkbox-wrapper">
              <span style={{ fontSize: "18px", lineHeight: 1.5714 }}>
                {intl.formatMessage({
                  id: "app.scheduling.supporting_community",
                })}
              </span>
            </label>
          ) : (
            <Checkbox checked={isChecked} onChange={onChange}>
              {order.is_day_center
                ? `${name} (${intl.formatMessage({
                    id: "app.scheduling.day_center",
                  })})`
                : name}
            </Checkbox>
          )}
        </CheckboxWrapper>
        <PartialOrderTooltip order={order} events={events} />
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          flexDirection: "column",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            flexDirection: "row",
          }}
        >
          {order.supporting_community ? (
            <Title
              level={4}
              style={{
                padding: "0px 5px",
                margin: 0,
              }}
            >
              1/1
            </Title>
          ) : (
            <Title
              level={4}
              style={{
                color:
                  planned > required && (!isTotalOrder || mode === "scheduling")
                    ? "red"
                    : "inherit",
                padding: "0px 5px",
                margin: 0,
              }}
            >
              {planned}/{required}
            </Title>
          )}

          {!isTotalOrder && planned > required ? (
            <Tooltip
              title={intl.formatMessage({
                id: "app.scheduling.deviationWarning",
              })}
              color={"red"}
              key={"warning"}
            >
              <WarningOutlined style={{ padding: "0 5px", color: "red" }} />
            </Tooltip>
          ) : null}

          {isTotalOrder && planned > required && mode !== "scheduling" ? (
            <Tooltip
              title={intl.formatMessage({
                id: "app.scheduling.totalOrderDeviationWarning",
              })}
              color={"orange"}
              key={"warning"}
            >
              <WarningOutlined style={{ padding: "0 5px", color: "orange" }} />
            </Tooltip>
          ) : null}

          {isTotalOrder && mode === "scheduling" ? (
            <Tooltip
              title={intl.formatMessage({
                id: "app.scheduling.totalOrderInfo",
              })}
              color={color}
              key={"info"}
            >
              <InfoCircleOutlined style={{ padding: "0 5px" }} />
            </Tooltip>
          ) : null}
        </div>
        {showApproved && (
          <div style={{ display: "flex", alignItems: "center" }}>
            <Tag
              style={{ margin: 0 }}
              color={approved === planned ? "#5850ec" : "#f50"}
            >
              {approved}
            </Tag>
            {renderDeleteButton && (
              <DeleteEventsButton
                events={unApprovedEvents}
                currentDate={currentDate}
              />
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default OrderListItem;
